module.exports = __webpack_public_path__ + "img/team-work-2.ce35657f.jpg";